import { InternalAxiosRequestConfig } from 'axios';

import { getCookie } from './getCookie';

export const setAxiosHeader = (config: InternalAxiosRequestConfig<unknown>): InternalAxiosRequestConfig<unknown> => {
	const token = getCookie(`CP_SAS_TOKEN`);
	const impersonateUserId = getCookie(`CP_SAS_IMPERSONATE-USER-ID`);
	const impersonateEndUserId = getCookie(`CP_SAS_IMPERSONATE-ENDUSER-ID`);

	if (token) {
		config.headers.Authorization = String(token);
	}

	if (impersonateUserId) {
		config.headers[`impersonate-user-id`] = String(impersonateUserId);
	}

	if (impersonateEndUserId) {
		config.headers[`impersonate-end-user-id`] = String(impersonateEndUserId);
	}

	return config;
};
